module.exports = __webpack_public_path__ + "img/skyblueTopBg.9538d4b2.png";